import { Icon, Space } from '@/components/core-v2'

import { StatusTag } from '.'

interface ApprovalStatusTagProps {
  tagContent: {
    color: string
    text: string
  }
}

export const ApprovalStatusTag = ({ tagContent }: ApprovalStatusTagProps) => {
  const { color, text } = tagContent

  if (text === '') {
    return null
  }
  return (
    <Space>
      <StatusTag color={color}>
        <Space isflex mr={2}>
          {text}
        </Space>
        <Icon name={color.includes('Info') ? 'circleCheck' : 'circleWarning'} size="default" />
      </StatusTag>
    </Space>
  )
}
